import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as Mail } from 'assets/images/mail.svg';
import { ReactComponent as Phone } from 'assets/images/phone.svg';
import { ReactComponent as Application } from 'assets/images/writting-file.svg';
import { ReactComponent as Documentation } from 'assets/images/open-book.svg';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Header = styled.h1`
  color: ${ColorPalette.HEX.CharlestonGreen};
  font-size: 24px;
  line-height: 32px;
  font-weight: 600;
  margin-bottom: 24px;

  @media ${({ theme }) => theme.device.desktop} {
    font-size: 40px;
    line-height: 48px;
    margin-bottom: 16px;
  }
`;

export const Detail = styled.h2`
  color: ${ColorPalette.HEX.DimGray};
  font-size: 16px;
  line-height: 28px;
  margin-bottom: 16px;

  @media ${({ theme }) => theme.device.desktop} {
    font-size: 28px;
    line-height: 40px;
  }
`;

export const Countries = styled.ul``;

export const Country = styled.li`
  margin: 24px 0;
`;

export const CountryName = styled.h3`
  font-size: 20px;
  font-weight: 600;
  line-height: 1.4;
  letter-spacing: -0.2px;
  color: ${ColorPalette.HEX.DimGray};
`;

export const Channel = styled.div`
  margin: 8px 0;
  display: flex;
  align-items: center;
  color: ${ColorPalette.HEX.DimGray};
`;

export const ChannelInfo = styled.p`
  margin: 0 16px;
  font-size: 20px;
  font-weight: normal;
  line-height: 1.4;
  letter-spacing: -0.2px;
  color: ${ColorPalette.HEX.DimGray};
`;

export const MailIcon = styled(Mail)`
  width: 24px;
`;

export const PhoneIcon = styled(Phone)`
  width: 24px;
`;

export const ApplicationIcon = styled(Application)`
  width: 24px;
  height: 24px;
`;

export const DocumentationIcon = styled(Documentation)`
  width: 24px;
  height: 24px;
`;